/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AdminPromoteRequest,
    GenerateCoverImageRequest,
    UpdateConfigResponse,
    WithdrawTransactionExportOptions,
} from '../models';

export interface AdminDashboardApiControllerExportWithdrawTransactionsAsCSVRequest {
    withdrawTransactionExportOptions: WithdrawTransactionExportOptions;
}

export interface AdminDashboardApiControllerGenerateCoverImageRequest {
    generateCoverImageRequest: GenerateCoverImageRequest;
}

export interface AdminDashboardApiControllerPromoteRequest {
    adminPromoteRequest: AdminPromoteRequest;
}

/**
 * 
 */
export class AdminDashboardApi extends runtime.BaseAPI {

    /**
     */
    async adminDashboardApiControllerExportWithdrawTransactionsAsCSVRaw(requestParameters: AdminDashboardApiControllerExportWithdrawTransactionsAsCSVRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.withdrawTransactionExportOptions === null || requestParameters.withdrawTransactionExportOptions === undefined) {
            throw new runtime.RequiredError('withdrawTransactionExportOptions','Required parameter requestParameters.withdrawTransactionExportOptions was null or undefined when calling adminDashboardApiControllerExportWithdrawTransactionsAsCSV.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/withdraw-transactions:export-csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.withdrawTransactionExportOptions,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async adminDashboardApiControllerExportWithdrawTransactionsAsCSV(requestParameters: AdminDashboardApiControllerExportWithdrawTransactionsAsCSVRequest): Promise<string> {
        const response = await this.adminDashboardApiControllerExportWithdrawTransactionsAsCSVRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async adminDashboardApiControllerGenerateCoverImageRaw(requestParameters: AdminDashboardApiControllerGenerateCoverImageRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.generateCoverImageRequest === null || requestParameters.generateCoverImageRequest === undefined) {
            throw new runtime.RequiredError('generateCoverImageRequest','Required parameter requestParameters.generateCoverImageRequest was null or undefined when calling adminDashboardApiControllerGenerateCoverImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/images:generateCoverImage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generateCoverImageRequest,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async adminDashboardApiControllerGenerateCoverImage(requestParameters: AdminDashboardApiControllerGenerateCoverImageRequest): Promise<string> {
        const response = await this.adminDashboardApiControllerGenerateCoverImageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async adminDashboardApiControllerPromoteRaw(requestParameters: AdminDashboardApiControllerPromoteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.adminPromoteRequest === null || requestParameters.adminPromoteRequest === undefined) {
            throw new runtime.RequiredError('adminPromoteRequest','Required parameter requestParameters.adminPromoteRequest was null or undefined when calling adminDashboardApiControllerPromote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/admin:promote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.adminPromoteRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async adminDashboardApiControllerPromote(requestParameters: AdminDashboardApiControllerPromoteRequest): Promise<void> {
        await this.adminDashboardApiControllerPromoteRaw(requestParameters);
    }

    /**
     */
    async adminDashboardApiControllerUpdateConfigRaw(): Promise<runtime.ApiResponse<UpdateConfigResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/config:refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async adminDashboardApiControllerUpdateConfig(): Promise<UpdateConfigResponse> {
        const response = await this.adminDashboardApiControllerUpdateConfigRaw();
        return await response.value();
    }

}
